import { makeDataState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  contest: makeDataState(),
  contestEvent: makeDataState(),
  contestRanking: makeDataState(),
  contestStory: makeDataState(),
  myContestStory: makeDataState(),
  storyRemind: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_CONTEST}_SUCCESS`:
      return {
        ...state,
        contest: {
          ...state.contest,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_CONTEST}_ERROR`:
      return {
        ...state,
        contest: {
          ...state.contest,
          isLoaded: true,
        },
      };

    case `${t.FETCH_CONTEST_EVENT}_ERROR`:
    case `${t.FETCH_CONTEST_EVENT}_PENDING`:
      return {
        ...state,
        contestEvent: {
          ...state.contestEvent,
          isLoaded: true,
          data: {
            ...state.contestEvent,
            vote: {
              ...state.contestEvent.vote,
              voteStories: [],
            },
          },
        },
      };
    case `${t.FETCH_CONTEST_EVENT}_SUCCESS`:
      return {
        ...state,
        contestEvent: {
          ...state.contestEvent,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_CONTEST_COMPLETE}_SUCCESS`:
      return {
        ...state,
        contestEvent: {
          ...state.contestEvent,
          data: {
            ...state.contestEvent.data,
            join: {
              ...state.contestEvent.data.join,
              status: 'RECEIVED',
            },
          },
        },
      };

    case `${t.FETCH_CONTEST_JOIN_MY_STORY}_SUCCESS`:
      return {
        ...state,
        myContestStory: {
          ...state.myContestStory,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_CONTEST_JOIN_MY_STORY}_ERROR`:
      return {
        ...state,
        myContestStory: {
          ...state.myContestStory,
          isLoaded: true,
        },
      };

    case `${t.FETCH_CONTEST_STORY}_SUCCESS`:
      return {
        ...state,
        contestStory: {
          ...state.contestStory,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_CONTEST_STORY_VOTE}_SUCCESS`:
      return {
        ...state,
        contestStory: {
          ...state.contestStory,
          data: {
            ...state.contestStory.data,
            isVoted: true,
          },
        },
        contestEvent: {
          ...state.contestEvent,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: {
            ...state.contestEvent.data,
            vote: {
              ...state.contestEvent.data.vote,
              voteStories: state.contestEvent.data.vote.voteStories.concat(
                action.meta.story
              ),
            },
          },
        },
      };

    case `${t.FETCH_CONTEST_RANKING}_SUCCESS`:
      return {
        ...state,
        contestRanking: {
          ...state.contestRanking,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_CONTEST_STORY_REMIND}_SUCCESS`:
      return {
        ...state,
        storyRemind: {
          ...state.storyRemind,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_CONTEST_STORY_REMIND}_SUCCESS`:
      return {
        ...state,
        storyRemind: {
          ...state.storyRemind,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case t.RESET:
      return {
        storyRemind: makeDataState(),
        contestStory: makeDataState(),
        contestEvent: makeDataState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/events/contest/reducer.js